<template>
  <v-row align="start" justify="start">
    <v-col cols="12" class="text-h5 grey--text">
      {{ INT($store.state.userData.preferred_name) }},{{ $t("label_Welcome") }}!
    </v-col>
    <v-col cols="12" :style="{ 'min-height': height2 }">
      <v-list-item dense>
        <v-list-item-title class="text-h6 grey--text">{{
          $t("label_Shortcut")
        }}</v-list-item-title>
        <v-list-item-action>
          <v-btn @click="dialog = true" icon>
            <v-icon class="material-icons-round">more_vert</v-icon>
          </v-btn>
        </v-list-item-action>
      </v-list-item>

      <div class="grid-container grid-container--fill">
        <v-skeleton-loader
          :loading="loading"
          transition="fade-transition"
          v-for="(item, index) in urlList"
          :key="index"
          class="rounded-lg white grid-element"
          type="list-item-avatar"
        >
          <v-card class="rounded-lg" :elevation="0">
            <v-list-item class="pa-0 ma-0" dense flat>
              <v-list-item-avatar class="mr-1">
                <v-btn icon @click="goUrl(item)" color="primary">
                  <v-icon class="material-icons-round md-36"
                    >arrow_forward</v-icon
                  >
                </v-btn>
              </v-list-item-avatar>
              <v-list-item-title class="text-subtitle-2 text-left">{{
                INT(item.title)
              }}</v-list-item-title>
            </v-list-item>
          </v-card>
        </v-skeleton-loader>
      </div>
    </v-col>
    <v-col cols="12">
      <div
        class="text-center"
        style="font-size:12px;color:rgba(0,0,0,0.38);height:30px;line-height:30px;"
      >
        © {{ new Date().getFullYear() }} MRC International Group Limited. All
        rights reserved.
        <a
          href="https://privacy.essencehr.io/"
          target="_blank"
          style="color:var(--main-color);text-decoration: none"
          >Privacy Policy</a
        >
        and
        <a
          href="https://terms.essencehr.io/"
          target="_blank"
          style="color:var(--main-color);text-decoration: none"
          >Term of Use.</a
        >
      </div>
    </v-col>
    <mrc_ess_myDialog
      :title="$t('编辑捷径')"
      @flag="flag"
      width="680"
      v-model="dialog"
      :disabled="true"
      @cancel="cancel"
      @success="success"
    >
      <v-list-item class="item">
        <v-list-item-content>
          <v-list-item-title v-text="'菜单名称'"></v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <draggable
        v-model="desserts"
        animation="1000"
        @start="onStart"
        @end="onEnd"
      >
        <transition-group>
          <v-list-item
            v-for="(item, index) in desserts"
            :key="item.id"
            class="item"
          >
            <v-list-item-content>
              <v-list-item-title v-text="INT(item.title)"></v-list-item-title>
            </v-list-item-content>
            <v-list-item-action>
              <!-- <v-btn icon>
                <v-icon color="grey lighten-1">mdi-information</v-icon>
              </v-btn> -->
              <v-btn
                rounded
                depressed
                @click="changeCheck(item, index)"
                :color="item.check ? 'primary' : '#e0e0e0'"
              >
                选择
              </v-btn>
            </v-list-item-action>
          </v-list-item>
        </transition-group>
      </draggable>
    </mrc_ess_myDialog>
  </v-row>
</template>
<script>
import draggable, { filter } from "vuedraggable"
export default {
  name: "Dashboard",
  components: {
    draggable,
  },
  data() {
    return {
      dialog: false,
      show: false,
      loading: true,
      curTab: "tab-1",
      colorss: [
        "red",
        "pink",
        "purple",
        "indigo",
        "blue",
        "cyan",
        "teal",
        "green",
        "blue-grey",
        "amber",
      ], //testdata
      colorss2: [
        "amber",
        "cyan",
        "purple",
        "blue",
        "pink",
        "indigo",
        "green",
        "blue-grey",
        "teal",
        "red",
      ], //testdata
      drag: false,
      //定义要被拖拽对象的数组
      myArray: [
        { people: "cn", id: 10, name: "www.itxst.com" },
        { people: "cn", id: 20, name: "www.baidu.com" },
        { people: "cn", id: 30, name: "www.taobao.com" },
        { people: "us", id: 40, name: "www.yahoo.com" },
      ],
      desserts: [],
      urlList: [],
    }
  },
  created() {
    this.$store.state.homeUrlList.length > 0
      ? (this.urlList = this.$store.state.homeUrlList)
      : (this.urlList = JSON.parse(sessionStorage.getItem("allMenuUrlList")))
    this.desserts = JSON.parse(sessionStorage.getItem("allMenuUrlList")).map(
      (item, index) => {
        let isNo = false
        this.urlList.forEach((item2) => {
          if (item2.url == item.url) isNo = true
        })
        if (isNo) {
          return { ...item, id: index + 10, check: true }
        } else return { ...item, id: index + 10, check: false }
      }
    )
    // console.log(this.desserts, "aaaa")
  },
  computed: {
    height2() {
      // return (Number(this.$store.state.calcHeight.replace('px', '')) - 50) + 'px'
      return Number(this.$store.state.calcHeight.replace("px", "")) - 90 + "px"
    },
    taber() {
      return [
        this.$t("label_myApplication"),
        this.$t("label_myApproval"),
        this.$t("label_representingApplication"),
        this.$t("label_representing&Approval"),
      ]
    },
    headers() {
      return [
        {
          text: this.$t("菜单名称"),
          align: "start",
          value: "title",
          sortable: false,
        },
        { text: "", value: "actions", sortable: false },
      ]
    },
    // urlList () {
    //   return this.desserts.filter((item) => {
    //     return item.check == true
    //   })
    // },
  },
  mounted() {
    const that = this
    setTimeout(() => {
      that.show = true
      that.loading = false
    }, 1000)
  },
  methods: {
    changeCheck(item, index) {
      item.check = !item.check
    },
    goUrl(item) {
      this.$store.commit("setMenuFunctionUuid", item.function_uuid)
      this.$router.push(item.url)
    },
    onStart() {
      this.drag = true
    },
    //拖拽结束事件
    onEnd() {
      this.drag = false
    },
    cancel() {
      this.dialog = false
    },
    success() {
      // this.$store.state.set_homeUrlList
      let arr = this.desserts.filter((item) => {
        return item.check == true
      })
      this.urlList = arr
      this.$store.commit("set_homeUrlList", arr)
      // this.urlList = this.desserts.filter(item => {
      //   return item.check == false
      // })
      this.dialog = false
    },
    flag() {},
  },
}
</script>
<style scoped>
.grid-container {
  display: grid;
}

.grid-container--fill {
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
}

.grid-container--fit {
  grid-template-columns: repeat(auto-fit, minmax(100px, 1fr));
}

.grid-element {
  /* background-color: deepPink; */
  margin: 8px;
  height: 150px;
  /* color: #fff; */
  /* border: 1px solid #fff; */
}
/*被拖拽对象的样式*/
.item {
  /* padding: 6px; */
  /* background-color: #fdfdfd; */
  border-bottom: solid 1px #eee;
  /* margin-bottom: 10px; */
  cursor: move;
}
/*选中样式*/
.chosen {
  border: solid 2px #3089dc !important;
}
</style>
